<template>
 <div class="register_container">
    <div class="register_form">
        <h1>Register</h1>
        <div v-for="(item,index) in aicha_clients" :key="`${index}`">
            {{item.firstname}}
        </div>
        <div class="register_inputs">
            <div class="half">
                <input type="text" v-model="clientAicha.firstname" class="register_control" placeholder="First Name">
                <input type="text" v-model="clientAicha.lastname" class="register_control" placeholder="Last Name">
            </div>
            <div class="half">
                <input type="email" v-model="clientAicha.email" class="register_control" placeholder="Email">
                <input type="text" v-model="clientAicha.phone" class="register_control" placeholder="Phone">
            </div>
            <div class="half">
                <input type="text" v-model="clientAicha.username" class="register_control" placeholder="Username">
                <input type="password" v-model="clientAicha.password" class="register_control" placeholder="Password">
            </div>
             <input type="password" v-model="clientAicha.confirm_password" class="register_control" placeholder="Confirm Password">
            <div class="signin" @click="SignUp">register</div>
        </div>
    </div>
 </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {

  props: [],
  data() {
    return {
        clientAicha:{
            firstname:"Aicha",
            lastname:"Ihospitality",
            email:"",
            phone:"",
            username:"",
            password:"",
            confirm_password:"",
        }
    };
  },
  computed:{
    ...mapGetters(["aicha_clients","client"])
  },
  methods:{
    ...mapActions(["addMore","getMore"]),
    SignUp(){
        console.log(this)
       console.log(this.clientAicha)
       this.addMore({...this.clientAicha})
    }
  },
  mounted(){
    this.getMore()
  }
};
</script>

<style >
.half{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
}
    .register_container{
            background: #264740;
            width: 100%;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
flex-direction: column;
    }
    .register_form{
        background: #f0774efa;
        padding: 12px;
        border-radius: 50px;
        width: 90%;
    }   
    .register_form h1{
            color: #fff;
            text-transform: uppercase;
            margin-bottom: 24px;
            
    }
    .register_inputs{
        display: flex;
        flex-direction: column;
        justify-content: center;
            align-items: center;
    }
    .register_control{
            margin: 12px 3px;
            height: 39px;
            font-size: 12px !important;
            text-align: center;
            border-radius: 50px;
    }
    .signin{
        background: #264740;
        color: #fff;
        width: 50%;
        padding: 8px;
        border-radius: 50px;
        margin-top: 24px;
        margin-bottom: 24px;
    }
    .forgot_pwd{
        font-size: 12px !important;
        color: #fff;
        font-weight: 600;
        text-decoration: underline;
        cursor: pointer;
    }
</style>
